/**
 * Remount key for routed management subtrees; uses Web Crypto when available (not Math.random).
 */
export function createManagementSubtreeEtag() {
  const c = typeof window !== 'undefined' ? window.crypto : undefined;
  if (c?.randomUUID) {
    return c.randomUUID();
  }
  if (c?.getRandomValues) {
    const buf = new Uint32Array(2);
    c.getRandomValues(buf);
    return `${buf[0].toString(16)}${buf[1].toString(16)}`;
  }
  return String(Date.now());
}
